import * as React from "react";
const SvgFiRrMugHotAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mug-hot-alt_svg__a)">
      <path
        fill="#062147"
        d="M20 10h-.115A3.102 3.102 0 0 0 17 6H3c-5.451.372-2 8.651-.589 10.912A6.88 6.88 0 0 0 8.216 20h3.567a6.88 6.88 0 0 0 5.742-3H20c4.814-.093 5.759-7.178 0-7m-8.217 8H8.216a4.88 4.88 0 0 1-4.131-2.179C3.541 15.3.494 8 3 8h14a.97.97 0 0 1 .729.325 1.03 1.03 0 0 1 .261.8c-.563 4.259-1.622 8.686-6.207 8.875M20 15h-1.412c.411-.968.73-1.972.954-3 1.209-.081 2.546.216 2.458 1.143A1.984 1.984 0 0 1 20 15M9.025 3V1a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0m4 0V1a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0m-8 0V1a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0M20 23a1 1 0 0 1-1 1H1a1 1 0 0 1 0-2h18a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mug-hot-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMugHotAlt;
